export default {
  isKieConfigured: false,
  credits: null,
  generating: false,
  taskId: null,
  generationId: null,
  progress: 0,
  status: null,
  output: null,
  error: null,
};
